import Vue from 'vue';
import api from '@groovepages/gd-lib/api';

const pagesUrl = () => `${ window.gdEnv.VUE_APP_API_URL }/groovepages`;
const coreUrl = () => `${ window.gdEnv.VUE_APP_API_URL }/groovedigital`;

export default {
  namespaced: true,
  state: {
    userMeta: {},
    zone: {},
    domain: {},
    records: []
  },
  getters: {
    records: state => {
      return state.records;
      
    },
    zone: state => {
      return state.zone;
    },
    domain: state => {
      return state.domain;
    },
  },
  mutations: {
    setRecords(state, { records, domain, zone }) {
      state.records = records;
      state.domain = domain;
      state.zone = zone;
    },
    clearRecords(state)
    {
      state.records = [];
      state.domain = null;
      state.zone = null;
    },
    addRecord(state, { record }) {
      console.log('this is the record inside addrecord');
      console.log(record);
      state.records.push(record);
    },
    updateRecord(state, { id, record }) {
      console.log('in update record');
      console.log(`this is the id ${  id}`);
      console.log(record);
      // state.records[state.records.findIndex(el => el.id === id)] = record;
      const recordIndex = state.records.findIndex(el => el.id === id);
      Vue.set(state.records, recordIndex, record);
    },
    removeRecord(state, { id }) {
      const deletedRecord = state.records.map(item => item.id).indexOf(id);
      state.records.splice(deletedRecord, 1);
    },
  },
  actions: {
    async getDnsRecords({ commit }, domainId) {
      const { status, domain, records, zone } = await api.get(`${ coreUrl() }/domains/fetch-dns-records/${ domainId }`);
      if(status == 'success')
      {
        commit('setRecords', { records, domain, zone });
        return true;
      }
      return false;
    },
    async addDnsRecord({ commit, getters }, { data }) {
      data.proxied = data.proxied ? 1 : 0;
      const record = await api.post(`${ pagesUrl() }/zones/${ getters.zone.id }/records`, data);
      console.log('this is the record');
      console.log(record);
      commit('addRecord', { record });
      console.log('this is the records set after commit');
      console.log(getters.editableRecords);
      return record;
    },
    async updateDnsRecord({ commit, getters }, { data }) {
      data.proxied = data.proxied ? 1 : 0;
      const record = await api.api('put', `${ pagesUrl() }/zones/${ getters.zone.id }/records/${ data.id }`, data);
      commit('updateRecord', { id: data.id, record });
      return record;
    },
    async deleteDnsRecord({ commit, getters }, { record: { id } }) {
      await api.delete(`${ pagesUrl() }/zones/${ getters.zone.id }/records/${ id }`);
      commit('removeRecord', { id });
    },
  }
};
